export default {
  from: {
    rules: [
      {
        required: true,
        message: "Выберите валюту",
        trigger: ["change", "blur"]
      }
    ]
  },
  to: {
    rules: [
      {
        required: true,
        message: "Выберите валюту",
        trigger: ["change", "blur"]
      }
    ]
  },
  city: {
    rules: [
      {
        required: true,
        message: "Выберите город",
        trigger: ["change", "blur"]
      }
    ]
  },
  fixedOut: {
    rules: [
      {
        required: true,
        message: "Введите курс",
        trigger: "blur"
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/CrossRate/validation.js